import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import CustomToast from '../../Component/CustomToast/CustomToast';

export const saveNotification = async ({
    title,
    content,
    endpoint,
    onSuccess = () => {},
    onError = () => {},
    onFinally = () => {}
}) => {
    const uniqueId = uuidv4();

    const notification = [
        {
            id: uniqueId,
            title,
            content
        }
    ];

    const headers = {
        'Content-Type': 'application/json',
    };

    try {
        const response = await axios.post(endpoint, notification, { headers });

        if (response.status === 200) {
            toast(<CustomToast message={'اعلان با موفقیت افزوده شد'} state={'success'} />);
            onSuccess(response.data);
        } else {
            toast(<CustomToast message={'خطا در ارسال اعلان'} state={'error'} />);
            onError(response);
        }
    } catch (error) {
        toast(<CustomToast message={'خطا در ارسال اعلان'} state={'error'} />);
        console.error('Error sending notification:', error);
        onError(error);
    } finally {
        onFinally();
    }
};
